import { Navigate, Route, Routes } from 'react-router-dom'
import DocumentJobsPage from './DocumentJobsPage'

export default function DocumentJobsRoutes() {
    return (
        <Routes>
            <Route index element={<DocumentJobsPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    )
}
